import { render, staticRenderFns } from "./NewBankaccount.vue?vue&type=template&id=460ce27e&"
import script from "./NewBankaccount.vue?vue&type=script&lang=js&"
export * from "./NewBankaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports